import { handleActions } from "redux-actions";
import { presets } from "glamor";

import {
    APP_LEGACY_LOADED,
    APP_MENU_STATE,
    APP_SIDE_PANEL_TOGGLE,
    APP_VIEWPORT,
    APP_LOGIN_DIALOG_SHOW,
    APP_WORKING_ORDER_TOGGLE,
} from "constants/action-types";

let viewport = "mobile";
Object.keys(presets).forEach((key) => {
    if (window.matchMedia && window.matchMedia(presets[key]).matches) {
        viewport = key;
    }
});

const initialState = {
    viewport,
    touchDevice: "ontouchstart" in window || navigator.maxTouchPoints ? true : false,
    menuState: "icon",
    sidePanelOpen: false,
    loginDialogOpen: false,
    loginRedirect: "",
    legacyLoaded: false,
    tryOpenWorkingOrder: false,
    width: window.innerWidth,
    height: window.innerHeight,
};

export const appInitReduxState = initialState;

export default handleActions(
    {
        [APP_LEGACY_LOADED]: (state, { payload }) => {
            return Object.assign({}, state, { legacyLoaded: payload });
        },
        [APP_VIEWPORT]: (state, { payload }) => {
            return Object.assign({}, state, {
                viewport: payload,
                width: window.innerWidth,
                height: window.innerHeight,
            });
        },
        [APP_MENU_STATE]: (state, { payload = {} }) => {
            return Object.assign({}, state, { menuState: payload });
        },
        [APP_SIDE_PANEL_TOGGLE]: (state, { payload = false }) => {
            return Object.assign({}, state, { sidePanelOpen: payload });
        },
        [APP_LOGIN_DIALOG_SHOW]: (state, { open = false, redirect = "" }) => {
            return Object.assign({}, state, {
                loginDialogOpen: open,
                loginRedirect: redirect,
            });
        },
        [APP_WORKING_ORDER_TOGGLE]: (state, { open = false }) => {
            return Object.assign({}, state, {
                tryOpenWorkingOrder: open,
            });
        },
    },
    initialState,
);
